import {createRoot, hydrateRoot} from 'react-dom/client';
import LocationScoutingSetDesignCrewScheduling from '../pages/LocationScoutingSetDesignCrewScheduling/LocationScoutingSetDesignCrewScheduling'
import "../index.css";
import "../pages/LocationScoutingSetDesignCrewScheduling/LocationScoutingSetDesignCrewScheduling.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<LocationScoutingSetDesignCrewScheduling {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <LocationScoutingSetDesignCrewScheduling {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).LocationScoutingSetDesignCrewSchedulingVC = {mount, hydrate, unmount}